module.exports = __webpack_public_path__ + "img/icon_box_3_3.8c493831.png";